/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ExamItemLevels200,
  GetApiV1ExamItemLevels401,
  GetApiV1ExamItemLevels500,
  GetApiV1ExamItemLevelsQueryResponse,
} from "../../types/examQuestionLibraryController/GetApiV1ExamItemLevels.ts";
import { dropDownListViewModelSchema } from "../dropDownListViewModelSchema.ts";

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ExamItemLevels200Schema = z.array(
  z.lazy(() => dropDownListViewModelSchema),
) as unknown as ToZod<GetApiV1ExamItemLevels200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ExamItemLevels401Schema =
  z.any() as unknown as ToZod<GetApiV1ExamItemLevels401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1ExamItemLevels500Schema =
  z.any() as unknown as ToZod<GetApiV1ExamItemLevels500>;

export const getApiV1ExamItemLevelsQueryResponseSchema = z.lazy(
  () => getApiV1ExamItemLevels200Schema,
) as unknown as ToZod<GetApiV1ExamItemLevelsQueryResponse>;
